import { useRef, useCallback } from 'react';

const BASE_SOUND_URL = window?.pfandConfig?.soundBaseUrl ?? '/app/assets/sounds';

// Universeller Audio-Singleton-Hook
export function useSingletonAudio(soundFile, volume = 0.7) {
  const audioRef = useRef();

  if (!audioRef.current) {
    audioRef.current = new window.Audio(soundFile);
    audioRef.current.volume = volume;
  }

  // Rückgabe: Funktion, die immer den Singleton spielt
  return useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    }
  }, []);
}

// Custom Hooks für einzelne Sounds (optional, für mehr Komfort)
export function useChestOpenSound(type = 'bronze', volume = 0.7) {
  return useSingletonAudio(`${BASE_SOUND_URL}/chest-${type}.mp3`, volume);
}
export function useCashRegisterSound(volume = 0.7) {
  return useSingletonAudio(`${BASE_SOUND_URL}/cash-register.mp3`, volume);
}
export function useMemberJoinedSound(volume = 0.7) {
  return useSingletonAudio(`${BASE_SOUND_URL}/member-joined.mp3`, volume);
}

export function playChestOpen(type = 'bronze', volume = 0.7) {
    const BASE_SOUND_URL = window?.pfandConfig?.soundBaseUrl ?? '/app/assets/sounds';
    const audio = new Audio(`${BASE_SOUND_URL}/chest_${type}.mp3`);
    audio.volume = volume;
    audio.play().catch(() => {});
}
